export default function Faq({ question, answer }) {
	return (
		<details>
			<summary>
				<h4>{question} ?</h4>
			</summary>
			<p>{answer}</p>
		</details> 
	);
}